import { CustomDataFormPage } from "~/pages/CustomDataFormPage";
import { queryClient, trpc } from "~/utils/trpc";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { selectCustomFieldOptions } from "~/utils/custom-field-options";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/details/$id/edit/$rowId")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const id = params.id;
    const [entity, label] = await Promise.all([
      queryClient.fetchQuery(trpc.customEntities.getCustomEntitiesById.queryOptions({ id: id, rowId: params.rowId })),
      queryClient.fetchQuery(
        trpc.customEntities.getCustomEntityDataLabel.queryOptions({ id: id, rowId: params.rowId }),
      ),
    ]);
    const data: Record<string, unknown> = {};
    const record = entity && "values" in entity ? entity.values : null;
    const values = record?.data;
    if (entity?.attributes && values) {
      for (const item of entity.attributes) {
        const value = values[item.id];
        if (item.type !== "Multi Select") {
          data[item.id] = value;
          continue;
        }
        if (value && (typeof value === "string" || Array.isArray(value))) {
          data[item.id] = selectCustomFieldOptions(value, item.options);
        }
      }
    }
    const rowId = params.rowId;

    // Include owner (DB-level field, not a custom attribute)
    if (record?.owner) {
      data["owner"] = record.owner;
    }

    return { entity, data, rowId, id, label };
  },
});

function RouteComponent() {
  const { entity, data, rowId, id, label } = Route.useLoaderData();
  useBreadCrumbs([
    {
      title: entity?.p_name || entity?.name || "Custom",
      link: `/${location.pathname.split("/")[1]}/data/custom/details/${id}/table`,
    },
    { title: label || "Edit", link: `/${location.pathname.split("/")[1]}/data/custom/details/${id}/edit/${rowId}` },
  ]);

  return (
    <div className="mx-5 pb-4">
      <h1 className="text-2xl font-bold mb-6">Edit {label || entity?.name}</h1>
      <div className="[&_.max-w-2xl]:max-w-full! [&_.mx-auto]:mx-0! [&>div]:mx-0!">
        <CustomDataFormPage entity={entity} data={data} rowId={rowId} id={id} hideHeader={true} title={label} />
      </div>
    </div>
  );
}
